export default "__VITE_ASSET__BOVC$iix__"